import { CarrierElementType, ContentType, NormalScodeParams } from "@/api/scode/scode_params";
import { fetchShareCardInfo } from "@/api/scode/share_card_info";
import { shareCardByH5 } from "@/utils/share/share";

type H5ShareCardRequestParams = {
  contentType: string;
  contentId: string;
  contentDetailId?: string;
  contentTypeConfig?: string;
  contentExtra?: Record<string, any>;
  shortCodeExtend?: Record<string, any>;
  posterInfo?: Record<string, any>;
  page_name?: string;
};

/**
 * 设置h5分享卡片信息(系统分享)
 */
const setH5ShareCardInfo = async (params: H5ShareCardRequestParams) => {
  let requestParams = {
    bizInfo: {
      contentType: params.contentType,
      contentId: params.contentId,
      contentDetailId: params.contentDetailId,
      contentTypeConfig: params.contentTypeConfig,
      contentExtra: params.contentExtra,
      shortCodeExtend: params.shortCodeExtend,
    },
    carrierContext: {
      carrierElements: [CarrierElementType.h5Link],
      posterInfo: params.posterInfo,
    },
    contentContext: {
      contentType: params.contentType as ContentType,
      contentId: params.contentId,
      contentExtra: {
        ...(params.contentExtra || {}),
        page_name: params.page_name,
      },
    },
    envContext: {
      bizCategory: "XD",
      bizSubCategory: "xdWxH5",
      terminalType: "h5",
      createTime: new Date().getTime(),
    },
  };
  const res = await fetchShareCardInfo(requestParams);
  if (res && res.data) {
    shareCardByH5(
      {
        title: res.data.urlShareTitle,
        desc: res.data.urlShareDesc,
        link: res.data.urlShareUrl,
        imgUrl: res.data.urlShareImg,
        scode: res.data.scode,
      },
      false,
    );
  }
};

export { setH5ShareCardInfo };
